<template >
<div class="container  py-5 px-5" v-if="lesson && topic && content">

    
      <div class="card mb-4"   >
        <div class="card-header py-3">
          <div class="row">
            <div class="col col-expand">
              <h3 class="m-0 font-weight-bold text-primary" >{{lesson.name}} / {{topic.name}} / {{content.name}}</h3>
            </div>

          </div>
        </div>
        <div class="card-body" >
          <div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>

                  <th class="text-primary">Сурагч</th>
                  
                  <th class="text-primary">
                    Дүн/{{content.totalScore}}/

                  </th>
                </tr>
              </thead>

              <tbody v-for="(group, gindex) in groups">
                <tr v-for="(student, sindex) in group.students">
    
                  <td>
                    
                    {{student.name}}
                    <span v-if="student.lastname && student.lastname.length>0">
                         {{student.lastname[0]}}
                    </span>
                  </td>
                  <td >
                    <div v-if="student && student.score && student.score.data">
                      <div class="row">
                        <div class="col">
                          <input class="form-control" placeholder="Оноо" v-bind:max="content && content.totalScore? content.totalScore:100" type="number" v-model.number="student.score.data.earnedScore" @change="scoreChanged(student)"/>
                        </div>
                        
                        <div  class="col" v-if="student.score.data.earnedScore">
                          <div class="row">
                            <div class="col" v-if="student.score.data.procent">
                              <div class="progress">
                                <div class="progress-bar bg-info" role="progressbar" v-bind:style="'width: '+student.score.data.procent+'%'" aria-valuemin="0" aria-valuemax="100">{{student.score.data.procent}} %</div>
                              </div>
                            </div>
                            <div class="col" v-else>
                              <div class="progress">
                                <div class="progress-bar bg-danger" role="progressbar" v-bind:style="'width: '+0+'%'" aria-valuemin="0" aria-valuemax="100">0 %</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                  </td>
          
                </tr>
              </tbody>
   
            </table>
          </div>
        </div>
      </div>
 
</div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment,{ max } from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode';
import LessonInfo from '../shared/LessonInfo';
export default {
    name: "ILessonContentScores",

    data() {
        return {
            lesson: null,
            topic:null,
            content:null,
            topics:[],
            types:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
                        
            display:0,
            tagText:null,
            dayStr:null,
            selectedCell:null,
            selectedTopicIndex:null,
            selectedGroupIndex:null,
            schools:[],
            teachers:[],
            school:null,
            teacher:null,
            groups:[]

            
        };
    },
    methods: {
        
      async _getQA(){


          var doc=await fb.db.collection("lessons").doc(this.lessonId).get();
          let lesson=doc.data();
          lesson.id=doc.id;
          this.lesson=lesson;
          this.groups=[];

          var topicDoc=await doc.ref.collection("topics").doc(this.topicId).get();
          let t=topicDoc.data();
          t.id=topicDoc.id;
          this.topic=t;

          var contentDoc=await topicDoc.ref.collection("details").doc(this.contentId).get();
          let c=contentDoc.data();
          c.id=contentDoc.id;
          this.content=c;
          var group={name: ''}
       
          group.students=[];
          this.getStudents(group);

          this.groups.push(group);
            

      },
      async getStudents(group){
        if(this.lesson){
          var querySnapshot=await fb.db.collection("lessons/"+this.lessonId+'/studentList').get();
          for(const stddata of querySnapshot.docs){
            if(stddata.data().studentRef!=null){
              var studentDoc=await stddata.data().studentRef.get();
              if(studentDoc.exists){
                let student=studentDoc.data();
                student.id=studentDoc.id;
                student.ref=studentDoc.ref;
                student.topics=[];
                student.score=Object.assign({}, { data:{earnedScore:null}, procent:0});

                  
                if(student){
                  var y = {};
                  y.data={earnedScore:null};
                  fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection("details").doc(this.contentId).collection('sstudents').doc(student.id).onSnapshot(sdoc=>{
                    if(sdoc.exists){
                      y.data=sdoc.data();
                      
                      student.score=Object.assign({}, y);
                    }
                  });
                  
                }
                group.students.push(student);
                if(group.students && group.students.length>0){
                  group.students.sort(function(a, b) {
                      if(a && b)
                        return a.name == b.name ? 0 : +(a.name > b.name) || -1;
                  });
                }
              }
              

            }
          }
        }
      },
      async getTopics(){
        if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups && this.lesson.groups.length>0){
          var topicSnapshot=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).collection("topics/"+this.topicId+"/details/"+this.contentId+"/scores").orderBy("createdAt","asc").get();
          if(topicSnapshot && !topicSnapshot.empty){
            this.topics=[];
            for(const doc of topicSnapshot.docs){
              let object=doc.data();
              object.id = doc.id;
              object.groups=[];
              object.procent=0;
              if(object && object.numberOfUnderstand && object.numberOfTotalStatus){
                object.procent=(object.numberOfUnderstand*100/object.numberOfTotalStatus).toFixed(2)
              }
              
              this.topics.push(object);
            }
      
          }
          
        }
      },

      _addTopic(gdata, i, j){
        this.dayStr=null;
        this.selectedTopicIndex=i;
        this.selectedGroupIndex=j;
        this.selectedCell=gdata;
        $('#exampleModal').modal('toggle');
      },
      _chooseTeacher(gdata, i, j){
        this.teacher=null;
        this.selectedTopicIndex=i;
        this.selectedGroupIndex=j;
        this.selectedCell=gdata;
        $('#teacherModal').modal('toggle');
      },
      
 
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
    
      setPublished(value, lesson){

      },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      scoreChanged(student){

        if(student && student.id && student.score && student.score.data && student.score.data.earnedScore){
          var maxScore=100;
          if(this.content && this.content.totalScore){
            maxScore=this.content.totalScore;
          }
          if(student.score.data.earnedScore> maxScore){
            alert("Дээд онооноос хэтэрсэн байна.");
            fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection("details").doc(this.contentId).collection('sstudents').doc(student.id).set({
              modifiedAt: new Date()
            }, {merge:true});
            return ;
          }
          var procent=null;
          if(this.content && this.content.totalScore){
            procent=(student.score.data.earnedScore*100/this.content.totalScore)
          }
          fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection("details").doc(this.contentId).collection('sstudents').doc(student.id).set({
            modifiedAt: new Date(),
            earnedScore:student.score.data.earnedScore,
            procent: procent
          }, {merge:true});
        }
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
      LessonInfo
    },
    props: {
      lessonId: { 
          required: true,
      },
      topicId:{
        required:true
      },
      contentId:{
        required:true
      },
      programId:{
        required:false
      },
      groupId:{
        required:false
      }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

